// extracted by mini-css-extract-plugin
export var banner = "_3z-0";
export var icon = "_3z-1";
export var message = "_3z-2";